module.exports = __webpack_public_path__ + "static/media/PennyDreadful.96f6af4e.png";